<template>
    <li class="partial_result_item">
        <a :href="data.link" target="_blank" class="partial_result_img_box">
            <img class="partial_result_img" v-if="data.cover && data.cover.substring(0,5) == 'https'" :src="data.cover" alt='版权登记'>
            <img class="partial_result_img" v-else-if="data.cover && data.cover.substring(0,5) != 'https' && data.cover.charAt(data.cover.length-1) != 'g'" :src="data.cover" alt='版权登记'>
            <img class="partial_result_img" v-else-if="data.cover && data.cover.substring(0,5) != 'https' && data.cover.charAt(data.cover.length-1) == 'g'" :src="bqjUrlTh+'/bqjvip/file/downLoad?fileUrl='+data.cover" alt='版权登记'>
            <img v-else class="partial_result_img_icon"
                 :src="data.type == 'word' ? textIcon : data.type == 'music' ? musicIcon : fileIcon  "  alt='版权登记'>

        </a>
        <Tooltip style="max-width: 100%;" max-width="200" :content="data.title"><p class="partial_result_title">
            {{data.title }}</p></Tooltip>
        <Tooltip style="max-width: 100%;" max-width="200" :content="data.link"><p class="partial_result_url">{{data.link
            }}</p></Tooltip>

        <div class="partial_result_msg">
            <span class="partial_result_name">{{ data.platformName }}</span>
            <router-link class="monitor_item_btn"
                         :to="data.link ? '/evidenceWeb?url=' + encodeURIComponent(data.link) : '/evidenceWeb' ">取证
            </router-link>
        </div>

        <div v-if="isChoice" @click="checkedClick()" class="is_checked_icon">
            <img v-if="isChecked" src="../images/is_checked.png" alt='版权登记'>
            <img v-else src="../images/un_checked.png" alt='版权登记'>
        </div>

    </li>
</template>

<script>
// import {bqjUrl} from "../../../../config/config";
import {bqjUrl} from "@/config/config"
    export default {
        name: "monitorItem",
        data() {
            return {
                textIcon: require('@/assets/text_small_icon.png'),
                musicIcon: require('@/assets/music_small_icon.png'),
                fileIcon: require('@/assets/file_small_icon.png'),
                bqjUrlTh:""
            }
        },
        props: {
            data: {
                type: Object,
                default: {},
            },
            isChoice: {
                type: Boolean,
                default: false
            },
            isChecked: {
                type: Boolean,
                default: false
            }
        },
        methods: {
            checkedClick() {
                this.$emit("monitorItemFather", this.data.link);
            }
        },
        created() {
            this.bqjUrlTh = bqjUrl
        }

    }
</script>

<style scoped lang="less">
    .partial_result_item {
        width: 205px;
        height: 241px;
        box-sizing: border-box;
        background: #FFFFFF;
        box-shadow: 0 2px 40px 0 rgba(29, 31, 108, 0.04);
        border-radius: 4px;
        padding: 10px;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        position: relative;
    }

    .partial_result_item .partial_result_img_box {
        width: 185px;
        height: 142px;
        border-radius: 4px;
        background: #fcfcfc;
        display: flex;

    }

    .partial_result_item .partial_result_img {
        width: 100%;
        height: 100%;
        border-radius: 4px;
        display: block;
        object-fit: cover;
    }

    .partial_result_img_box .partial_result_img_icon {
        width: 50px;
        height: 42px;
        display: block;
        align-self: center;
        margin: 0 auto;
    }

    .partial_result_item .partial_result_url {
        width: 100%;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        color: #999999;
        font-size: 12px;
        /*padding-top: 10px;*/
        /*line-height: 1;*/
    }

    .partial_result_item .partial_result_title {
        width: 100%;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        color: #3A3A3A;
        font-size: 14px;
        padding-top: 10px;
        /*line-height:1;*/
    }

    .partial_result_item .partial_result_msg {
        display: flex;
        padding-top: 3px;
        justify-content: space-between;
        font-size: 14px;
        color: #3A3A3A;
        align-items: center;
    }

    .partial_result_msg .partial_result_name {
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        max-width: 64%;
        line-height: 1;
        color: #999999;
        font-size: 14px;
    }

    .monitor_item_btn {
        width: 64px;
        height: 26px;
        line-height: 26px;
        font-size: 12px;
        color: #333333;
        cursor: pointer;
        text-align: center;
        outline: none;
        background: #f6f6f6;
        border-radius: 2px;
        border: 1px solid #efefef;
        font-weight: 400;
    }


    .monitor_item_btn:hover {
        background: #FFD800;
        border: 1px solid #FFD800;
    }

    /deep/ .ivu-tooltip-rel {
        display: block;
    }

    /deep/ .ivu-tooltip-inner-with-width {
        word-break: break-all;
    }

    .partial_result_item .is_checked_icon {
        position: absolute;
        width: 28px;
        height: 28px;
        top: 10px;
        right: 10px;
        cursor: pointer;

        img {
            display: block;
            width: 100%;
            height: 100%;
        }
    }
</style>